/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Robot_Hud_Task_SectionInputs */

const en_robot_hud_task_section = /** @type {(inputs: Robot_Hud_Task_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current task`)
};

const fr_robot_hud_task_section = /** @type {(inputs: Robot_Hud_Task_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâche en cours`)
};

const ms_sg2_robot_hud_task_section = /** @type {(inputs: Robot_Hud_Task_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugasan semasa`)
};

/**
* | output |
* | --- |
* | "Current task" |
*
* @param {Robot_Hud_Task_SectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const robot_hud_task_section = /** @type {((inputs?: Robot_Hud_Task_SectionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Robot_Hud_Task_SectionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_robot_hud_task_section(inputs)
	if (locale === "fr") return fr_robot_hud_task_section(inputs)
	return ms_sg2_robot_hud_task_section(inputs)
});